export default "__VITE_ASSET__CmR4mYhr__"